import React, { useState } from 'react'
import ChatList from './ChatList'
import ChatBody from './ChatBody'
import { Card, Col, Drawer, Row } from 'antd'
import { Link } from 'react-router-dom'
import { FaChevronLeft } from 'react-icons/fa'
import './style.css'
import { useDispatch } from 'react-redux'
import { setAppLoading } from '../../../store/common/generalSlice'

const Chats = () => {
  const dispatch = useDispatch()

  const [selectedChat, setSelectedChat] = useState(null)
  const [hasChats, setHasChats] = useState(false)
  const [open, setOpen] = useState(false);
  
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const handleSelectedChat = (selectedChatData) => {
    if(selectedChatData){
      setSelectedChat(selectedChatData)
      setOpen(false)
      
      dispatch(setAppLoading(true))
    }
  }
  

  return (
    <Row id='chats'>
      <Col md={24} sm={24} xs={24} className="md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6">
        <div className='flex justify-between mb-4'>
          <h5 className='heading-5 text-slate-600 font-semibold'>Messages</h5>
          <Link to='/' className='cursor-pointer flex items-center'>
            <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
            <small className='ml-2 font-medium'>Back</small>
          </Link>
        </div>
        <Card bordered={false} className='p-0 mb-2'>
          <Row>
            <Col 
              sm={hasChats?8:24} 
              md={hasChats?6:24} 
              xs={24}
              className='border-r-2 border-slate-50 pt-2'
            >
              <div className='sm:hidden block py-2'>
                <div onClick={showDrawer} className='flex items-center'>
                  <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                  <small className='ml-2 font-medium'>Open Chat list</small>
                </div>
                <Drawer          
                  placement='left'
                  onClose={onClose} 
                  open={open}
                >
                  <ChatList selectedChatCb={handleSelectedChat} hasChats={(res)=>setHasChats(res)} />
                </Drawer>
              </div>
              <div className='sm:block hidden'>
                <ChatList selectedChatCb={handleSelectedChat} hasChats={(res)=>setHasChats(res)} />
              </div>
            </Col>
            <Col 
              sm={hasChats?16:24} 
              md={hasChats?18:24} 
              xs={24}
            >
              <ChatBody data={selectedChat} hasChats={hasChats} />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default Chats